import Table from "../../MUI_components/Table/table";
import AddGrn from "./addGrn";
import view from "./viewGrn";
import Title from "../../Card/title";
import Service from "../../../Service/Stock/grn.service";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import AddSupplier from "Components/Suppliers/Supplier/addSupplier";

const Grn = () => {
  //----------------------GRN----------------

  const grnTableHeadCells = [
    {
      id: (row) => row["code"],
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.CODE,
    },
    {
      id: (row) => row["supplier"]? row["supplier"]['name']:row['name'] ,
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.SUPPLIER,
    },
    {
      id: (row) => row["invoiceCode"],
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.INVOICE_NUMBER,
    },

    {
      id: (row) => row["invoiceDate"],
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.INVOICE_DATE,
    },
    {
      id: (row) => row["grnDate"],
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.GRN_DATE,
    },
    {
      id: (row) => row["totalAmount"],
      numeric: true,
      disablePadding: false,
      label: COLUMNS_NAME.TOTAL,
    },
    {
      id: (row) => row["isLocked"] == 1 ? <LockIcon/> : <LockOpenIcon/> ,
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.STATUS,
      align:'center'
    },
    {
      id: (row) => row["isFreeze"] == 1 ? <AcUnitIcon/> : ""  ,
      numeric: false,
      disablePadding: false,
      label: COLUMNS_NAME.FREEZ_STATUS,
      align:'center'
    },
  ];
  return (
    <>
      <Title>Goods received note</Title>
      <Table
        title="GRN"
        editable
        service={Service}
        searchable
        headCells={grnTableHeadCells}
        // customService={Service.getNotPaidGrn()}
        titleTwo = "Add Supplier"
        AddComponentTwo={AddSupplier}
        AddComponent={AddGrn}
        ViewComponent={view}
        lockable
        
      />
    </>
  );
};
export default Grn;
